// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VQFT","content":"styles_content__sfA6E"};